import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SelectOption } from '../../../types';
import { FormFieldAbstractComponent } from '../form-field-abstract.component';

@Component({
  selector: 'app-form-field-select',
  templateUrl: './form-field-select.component.html',
})
export class FormFieldSelectComponent
  extends FormFieldAbstractComponent
  implements AfterViewInit, OnChanges, OnDestroy
{
  @Input() focused = false;
  @Input() hasDeselectOption = false;
  @Input() localizeDate = false;
  @Input() multiple = false;
  @Input() options!: SelectOption[];

  @Input() sortBy:
    | 'none'
    | 'translated-label-asc'
    | 'translated-label-desc' = 'none';
  @Output()
  selectionChange: EventEmitter<any> =
    new EventEmitter<any>();

  @ViewChild('autoFocusInput')
  autoFocusInputRef!: NgSelectComponent;

  sortedOptions!: SelectOption[];

  private unsubOnDestroy: Subscription = new Subscription();

  constructor(private translate: TranslateService) {
    super();
    this.unsubOnDestroy.add(
      translate.onLangChange.subscribe(() => {
        this.sortedOptions.sort((a, b) =>
          this.optionsSortComparator(a, b)
        );
      })
    );
  }

  stringify(value: null | boolean | number | string) {
    return `${value}`;
  }

  ngAfterViewInit(): void {
    if (this.focused) {
      setTimeout(() => {
        this.autoFocusInputRef?.focus();
      }, 0);
    }
  }

  ngOnChanges(): void {
    this.sortedOptions = [...this.options];
    this.sortedOptions.sort((a, b) =>
      this.optionsSortComparator(a, b)
    );
  }

  get showError(): boolean {
    return this.field.touched && !this.field.valid;
  }

  private optionsSortComparator(
    a: SelectOption,
    b: SelectOption
  ): number {
    if (!this.sortBy) {
      return 0;
    }
    switch (this.sortBy) {
      case 'none': {
        return 0;
      }
      case 'translated-label-asc': {
        const translatedA = this.translate.instant(
          a.label
        ) as string;
        const translatedB = this.translate.instant(
          b.label
        ) as string;
        return translatedA.localeCompare(translatedB);
      }
      case 'translated-label-desc': {
        const translatedA = this.translate.instant(
          a.label
        ) as string;
        const translatedB = this.translate.instant(
          b.label
        ) as string;
        return translatedB.localeCompare(translatedA);
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubOnDestroy.unsubscribe();
  }
}
